import React from "react";

function SummaryChip({ label, value }) {
    return (
        <div className="rounded-xl border border-slate-200 bg-white px-4 py-3 shadow-sm dark:border-slate-800 dark:bg-slate-950">
            <p className="text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">
                {label}
            </p>
            <p className="mt-1 text-sm font-semibold text-slate-900 dark:text-white">
                {value || "--"}
            </p>
        </div>
    );
}

export default function ReportsSummaryHeader({ patient, reportsCount }) {
    return (
        <section className="rounded-[28px] border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-800 dark:bg-slate-950 sm:p-5">
            <div className="flex flex-col gap-4">
                <div>
                    <p className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500 dark:text-slate-400">
                        Informes
                    </p>
                    <h1 className="mt-1 text-xl font-semibold text-slate-900 dark:text-white sm:text-2xl">
                        {patient?.name || "Paciente"}
                    </h1>
                </div>
                <div className="grid gap-3 sm:grid-cols-3">
                    <SummaryChip label="C.I." value={patient?.govId} />
                    <SummaryChip
                        label="Edad"
                        value={patient?.age ? `${patient.age} años` : "--"}
                    />
                    <SummaryChip
                        label="Total de informes"
                        value={reportsCount}
                    />
                </div>
            </div>
        </section>
    );
}
